module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Everton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Everton.png
// module id = 2186
// module chunks = 4